import { render, staticRenderFns } from "./RenderAdvancedMarkdown.vue?vue&type=template&id=77ba4152&scoped=true&"
import script from "./RenderAdvancedMarkdown.vue?vue&type=script&lang=js&"
export * from "./RenderAdvancedMarkdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ba4152",
  null
  
)

export default component.exports